/**
 * `true` unless `value` is `null` or `undefined`.
 *
 * The API serialises with `WhenWritingNull`, so a field that is `null` on the server is an
 * *absent key* on the wire — `undefined`, not `null`, once it reaches the client. A field typed
 * `T | null` and checked with `!== null` therefore still reads as present when it never arrived,
 * which is a silent crash or a blank line on a receipt waiting to happen. Use this wherever an
 * optional API field is being checked for presence, instead of `!= null`/`!== null` scattered
 * inline — `eqeqeq` bans loose equality project-wide for good reason, and repeating the
 * exception at every call site is how the next one gets typed `!== null` again.
 */
export function isPresent<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
